<p [dcrHTMLKey]="dcrKey" class="disclaimer-container">No data applicable.</p>
